import { useAuth } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
// import { useContext } from 'react';
// import { ThemeContext } from '../context/ThemeContext';
import useSubscriptionCheck from '../hooks/useSubscriptionCheck'; // ✅ Import the hook
const Layout = ({ children }) => {
  useSubscriptionCheck(); // ✅ Call the hook here
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  // const { isDark, toggleTheme } = useContext(ThemeContext);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="bg-white text-black dark:bg-[#0E0A1F] dark:text-white min-h-screen flex flex-col">
      <header className="bg-gray-100 dark:bg-[#1C1235] p-4 flex justify-between items-center">
      <Link to="/dashboard" className="hover:text-purple-400 dark:hover:text-purple-300"><div className="flex justify-center gap-2">
          <img src="/Spark_01.png" alt="Sparks Logo" className="h-6" />
          <h1 className="text-xl font-bold">Sparks Scribe</h1>
        </div></Link>
        

        <div className="flex gap-4 items-center">
          {user && (
            <>
              <Link to="/dashboard" className="hover:text-purple-400 dark:hover:text-purple-300">Dashboard</Link>
              <Link to="/clients" className="hover:text-purple-400 dark:hover:text-purple-300">Clients</Link>

              {/* 🌗 Theme Toggle Button */}
              {/* <button
                onClick={toggleTheme}
                title="Toggle Theme"
                className="text-xl hover:scale-110 transition-transform"
              >
                {isDark ? '☀️' : '🌙'}
              </button> */}

              <button
                onClick={handleLogout}
                className="text-sm text-red-500 hover:text-red-600"
              >
                Logout
              </button>
            </>
          )}
        </div>
      </header>

      <main className="flex-1 px-4 py-6 bg-white dark:bg-[#0E0A1F]" >{children}</main>

      <footer className="bg-white dark:bg-[#1C1235] text-center p-4 text-sm text-gray-500 dark:text-gray-400">
        © {new Date().getFullYear()} Sparks Academy | All rights reserved
      </footer>
    </div>
  );
};

export default Layout;
